<template>
    <router-link to="/" class="sidebar-logo">
    <img
      class="for-light"
      src="../../assets/images/logo/logo.png"
      alt=""
    />
  </router-link>
</template>
<script>

export default {
    
}
</script>
<style scoped>
.sidebar-logo {
  display: block;
  overflow: hidden;
}

.sidebar-logo img {
  width: 190px;
  max-width: none;
  height: auto;
}
</style>